import React, { useEffect, useRef, useState } from 'react';
import { Input, Button } from 'reactstrap';
import styles from '../../../../../../assets/css/rstyling.module.css'
import Dropzone from 'react-dropzone';
import CreateIcon from '../../../../../../assets/images/create_icon.png'
import { useNavigate, useParams, useLocation } from 'react-router';
import PageHeader from '../../../../../../assets/components/pageheader/PageHeader';
import InpersonForumIcon from '../../../../../../assets/images/inperson_forum_icon.png'
import { createActivity, getActivity, updateActivity } from '../../../../../../actions/activities_actions';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert'
import { getProjectAudiences } from '../../../../../../actions/audience_actions';
import ArrowLeft from '../../../../../../assets/images/arrow_left.png';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';

const InpersonForum = (props) => {

    const history = useNavigate()
    const params = useParams()
    const formRef = useRef()
    const location = useLocation();
    const currentPath = location.pathname;
    const [isLoading, setLoading] = useState(true)
    const [isEdit, setEditMode] = useState(false)
    const [isPreview, setPreviewMode] = useState(false)
    const [isPublish, setPublishMode] = useState(false)

    const Priorities = ['low', 'medium', 'high'] //These values are set to show in dropdown as per backend requirements
    const [Audience, setAudience] = useState([])
    const dispatch = useDispatch()
    const [data, setData] = useState({
        bannerImage: '',
        name: '',
        description: '',
        duration: '',
        days: '',
        priority: '',
        startDate: '',
        audience: '',
        location: ''
    })

    const getAudienceDetails = () => {
        dispatch(getProjectAudiences(params.projectid))
            .then(response => {
                const audience = response.payload.content.map(audience => {
                    return {
                        id: audience._id,
                        name: audience.title
                    }
                })
                setAudience(audience)
            })
            .catch(err => {
               // console.log(err)
            })
    }

    useEffect(() => {
        getAudienceDetails()
    }, [])

    const onPreview = () => {
        if (formRef.current) {
            setPreviewMode(true)
            formRef.current.handleSubmit()
        }
    }

    const getPageHeader = () => {
        switch (currentPath) {
            case '/researcher/project/create-inpersonforum/' + params.projectid:
                return <div className="create_header"><PageHeader
                    heading={"Create Focus Group Discussion Activity"} img={CreateIcon}
                    btnText="Preview"
                    isDisable={false}
                    btnClick={() => onPreview()}
                /></div>
                break;

            case '/researcher/project/edit-inpersonforum/' + params.projectid + "/" + params.forumid:
                return <div className="project_header"><PageHeader
                    heading={"Edit Focus Group Discussion Activity"} img={InpersonForumIcon}
                    btnText="Preview"
                    isDisable={false}
                    btnClick={() => onPreview()}
                /></div>
                break;

            default:
                return <div className="create_header"><PageHeader
                    heading={"Create Focus Group Discussion Activity"} img={CreateIcon}
                    btnText="Preview"
                    isDisable={false}
                    btnClick={() => onPreview()}
                /></div>
                break;
        }
    }

    const getInpersonForumDetails = () => {
        dispatch(getActivity(params.forumid))
            .then((response) => {
                setData({
                    ...response.payload.content,
                    audience: response.payload.content.audience ? response.payload.content.audience._id : ""
                })
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.response ? err.response.data.content : "Something went wrong",
                    icon: 'error'
                })
            })
    }

    // getting data for edit
    useEffect(() => {
        const editUrl = `/researcher/project/edit-inpersonforum/${params.projectid}/${params.forumid}`
        const copyUrl = `/researcher/project/create-inpersonforum/${params.projectid}/${params.forumid}`

        if (currentPath === editUrl) {
            getInpersonForumDetails()
            setEditMode(true)

        } else if (currentPath === copyUrl) {
            getInpersonForumDetails()
        } else {
            setLoading(false)
        }
    }, [])

    return (
        <>
            {getPageHeader()}

            {/* Back Icon */}
            <span onClick={() => history("/researcher/project/activity/" + params.projectid)} style={{ cursor: 'pointer' }}>
                <img src={ArrowLeft} alt="" width="8px" />
                <label className="ml-2" style={{ cursor: 'pointer' }}>Back</label>
            </span>

            <div className="container-fluid mt-3">

                <div className="row">
                    <div className="col-12 form-group">
                        <label htmlFor="activityBanner">Activity Banner</label>
                        <div className="mx-3 mt-3 mb-4 _survey-steps_">

                            <LoadingOverlay tag="div" active={isLoading}
                                styles={{
                                    overlay: (base) => ({
                                        ...base,
                                        background: "#fff",
                                        opacity: 0.5,
                                        // position: 'fixed',
                                        // top: '20%'
                                    }),
                                }}
                                spinner={
                                    <Loader color="#6c757d" active type="ball-pulse" />
                                }>

                                <Formik
                                    initialValues={data}
                                    enableReinitialize={true}
                                    innerRef={formRef}
                                    onSubmit={(values, { setSubmitting }) => {

                                        setSubmitting(true);

                                        const formData = new FormData()

                                        formData.append('projectId', params.projectid)
                                        formData.append('name', values.name)
                                        values.bannerImage && formData.append('bannerImage', values.bannerImage)
                                        formData.append('description', values.description)
                                        formData.append('activityType', 'Focus Group Discussion')
                                        formData.append('priority', values.priority)
                                        isPreview ? formData.append('status', 'draft') : formData.append('status', 'scheduled')
                                        formData.append('startDate', values.startDate)
                                        formData.append('duration', values.duration)
                                        values.days && formData.append('days', values.days)
                                        values.audience && formData.append('audience', values.audience)
                                        formData.append('location', values.location)

                                        Swal({
                                            title: "Please wait!",
                                            text: "Saving data...",
                                            type: "info",
                                            buttons: false,
                                            closeModal: false,
                                            closeOnClickOutside: false
                                        });

                                        if (isEdit) {
                                            dispatch(updateActivity(params.forumid, formData, 3))
                                                .then(response => {
                                                    Swal.stopLoading();
                                                    Swal.close();
                                                    isPublish ?
                                                        Swal({
                                                            title: response.payload.title ? response.payload.title : "Created",
                                                            text: response.payload.message ? response.payload.message : 'Focus Group Created',
                                                            icon: 'success'
                                                        }).then(() => {
                                                            history('/researcher/project/activity/' + params.projectid)
                                                        })
                                                        :
                                                        history({
                                                            pathname: `/researcher/project/preview-inpersonforum/${params.projectid}/${response.payload.content._id}`,
                                                            state: { from: 'create' }
                                                        })
                                                })
                                                .catch(err => {
                                                    Swal({
                                                        title: err.response ? err.response.data.name : "Error",
                                                        text: err.response ? err.response.data.content : "Please try again",
                                                        icon: 'error'
                                                    }).then(() => {
                                                        Swal.stopLoading();
                                                        Swal.close();
                                                    })
                                                })
                                        } else {
                                            dispatch(createActivity(formData, 3))
                                                .then(response => {
                                                    Swal.stopLoading();
                                                    Swal.close();
                                                    isPublish ?
                                                        Swal({
                                                            title: response.payload.title ? response.payload.title : "Created",
                                                            text: response.payload.message ? response.payload.message : 'Focus Group Created',
                                                            icon: 'success'
                                                        }).then(() => {
                                                            history('/researcher/project/activity/' + params.projectid)
                                                        })
                                                        :
                                                        history({
                                                            pathname: `/researcher/project/preview-inpersonforum/${params.projectid}/${response.payload.content._id}`,
                                                            state: { from: 'create' }
                                                        })
                                                })
                                                .catch(err => {
                                                    Swal({
                                                        title: err.response ? err.response.data.name : "Error",
                                                        text: err.response ? err.response.data.content : "Please try again",
                                                        icon: 'error'
                                                    }).then(() => {
                                                        Swal.stopLoading();
                                                        Swal.close();
                                                    })
                                                })
                                        }


                                    }}


                                    const validationSchema={Yup.object().shape({
                                        name: Yup.string().required("* Activity Name is required"),
                                        description: Yup.string().required("* Description is required"),
                                        startDate: Yup.date().required("* Start Date is required"),
                                        duration: Yup.number().required("* Duration is required"),
                                        days: Yup.number().required("* Duration is required"),
                                        priority: Yup.string().required("* Priority is required"),
                                        // audience: Yup.string().required("* Audience is required"),
                                        location: Yup.string().required("* Location is required"),

                                    })}


                                >
                                    {props => {
                                        const {
                                            values,
                                            touched,
                                            errors,
                                            isSubmitting,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            setFieldValue
                                        } = props;

                                        const startDate = new Date(values.startDate)
                                        values.startDate = startDate.getFullYear() + "-" + ("0" + (startDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (startDate.getDate())).slice(-2) 

                                        return (
                                            <form autoComplete="off" onSubmit={handleSubmit}>

                                                {/* Start of form */}

                                                <div className='row'>
                                                    <div className='col-12 mb-3'>
                                                        {/* Image Display & Dropzone */}
                                                        {values.bannerImage ? (

                                                            // Image Display
                                                            <div className="pt-3">
                                                                <div className="position-relative">
                                                                    <span className="questionImg_close" style={{ left: "97%", marginLeft: 0 }} onClick={() => setFieldValue('bannerImage', '')}>&times;</span>
                                                                    <img src={typeof values.bannerImage === 'string' ? values.bannerImage : URL.createObjectURL(values.bannerImage)} className={`img-fluid border ${styles.banner_image}`} style={{ borderRadius: '10px', maxHeight: 400, width: 'max-content' }} alt="img" />
                                                                </div>
                                                            </div>

                                                        ) : (

                                                            // Image Drop Zone 
                                                            < div className="dropzone-wrapper dropzone-wrapper-sm">
                                                                <Dropzone multiple={false} accept={".jpg, .jpeg, .png"} onDrop={file => setFieldValue('bannerImage', file[0])} value={values.bannerImage}>
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <div className="dropzone-content" style={{ cursor: 'pointer' }}>
                                                                                <p>
                                                                                    <span className={styles.upload_media_icon} style={{ width: 100, height: 100, backgroundSize: 55, verticalAlign: "middle" }}></span>Try dropping image here, or click to select image to upload.
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>

                                                        )}
                                                    </div>

                                                    <div className="col-12 form-group">
                                                        <label htmlFor="activityName">Activity Name</label>
                                                        <Input type="text"
                                                            className={errors.name && touched.name ? styles.is_invalid : 'valid'}
                                                            name="name"
                                                            placeholder="Activity Name"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.name}
                                                        />

                                                        {errors.name && touched.name && (
                                                            <div>
                                                                {errors.name}
                                                            </div>
                                                        )}

                                                    </div>
                                                    <div className="col-12 form-group">
                                                        <label htmlFor="description">Description</label>
                                                        <Input type="text"
                                                            className={errors.description && touched.description ? styles.is_invalid : 'valid'}
                                                            name="description"
                                                            placeholder="Description"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.description}
                                                        />

                                                        {errors.description && touched.description && (
                                                            <div>
                                                                {errors.description}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="duration">Duration</label>
                                                        <Input type="number"
                                                            className={errors.days && touched.days ? styles.is_invalid : 'valid'}
                                                            name="days"
                                                            placeholder="Duration"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.days}
                                                        />

                                                        {errors.days && touched.days && (
                                                            <div>
                                                                {errors.days}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="duration">Duration per Day (Minutes)</label>
                                                        <Input type="number"
                                                            className={errors.duration && touched.duration ? styles.is_invalid : 'valid'}
                                                            name="duration"
                                                            placeholder="Duration"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.duration}
                                                        />

                                                        {errors.duration && touched.duration && (
                                                            <div>
                                                                {errors.duration}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="priority">Priority</label>
                                                        <Input type="select"
                                                            className={errors.priority && touched.priority ? styles.is_invalid : 'form-control valid'}
                                                            name="priority"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.priority}
                                                        >
                                                            <option value="">Select</option>
                                                            {
                                                                Priorities.map(priority => {
                                                                    return <option value={priority}>{priority}</option>
                                                                })
                                                            }
                                                        </Input>

                                                        {errors.priority && touched.priority && (
                                                            <div>
                                                                {errors.priority}
                                                            </div>
                                                        )}

                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="startDate">Start Date</label>
                                                        <Input type="date"
                                                            className={errors.startDate && touched.startDate ? styles.is_invalid : 'valid'}
                                                            name="startDate"
                                                            placeholder="Duration"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.startDate}
                                                        />

                                                        {errors.startDate && touched.startDate && (
                                                            <div>
                                                                {errors.startDate}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="location">Location</label>
                                                        <Input type="text"
                                                            className={errors.location && touched.location ? styles.is_invalid : 'valid'}
                                                            name="location"
                                                            placeholder="Location"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.location}
                                                        />

                                                        {errors.location && touched.location && (
                                                            <div>
                                                                {errors.location}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-12 form-group">
                                                        <label htmlFor="audience">Audience</label>
                                                        <Input type="select"
                                                            className={errors.audience && touched.audience ? styles.is_invalid : 'valid'}
                                                            name="audience"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.audience}
                                                        >
                                                            <option value="">All Participants</option>
                                                            {
                                                                Audience.map(audience => {
                                                                    return <option value={audience.id}>{audience.name}</option>
                                                                })
                                                            }
                                                        </Input>

                                                        {errors.audience && touched.audience && (
                                                            <div>
                                                                {errors.audience}
                                                            </div>
                                                        )}

                                                    </div>

                                                 
                                                    <div className="col-12 text-right">
                                                        <Button className={` ${styles.bg_blue} mr-3`} type="submit" onClick={() => setPublishMode(true)}>
                                                            {values.status && values.status === 'draft' ? 'Publish' : 'Save'}
                                                        </Button>
                                                        <Button className={` bg-light text-muted ml-3`} type="button"
                                                            onClick={() => history('/researcher/project/activity/' + params.projectid)}
                                                            style={{ border: '1px solid #6c757d ' }}>
                                                            Cancel
                                                        </Button>
                                                    </div>

                                                </div>
                                            </form>
                                        )
                                    }}
                                </Formik>

                            </LoadingOverlay>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )


}

export default InpersonForum


